import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { FormsModule } from '@angular/forms';
import { OVERLAY_POSITIONS } from '../../../../constants/cdk-overly-position';

@Component({
  selector: 'adf-zoom-control',
  standalone: true,
  imports: [CdkConnectedOverlay, CdkOverlayOrigin, FormsModule],
  templateUrl: './zoom-control.component.html',
  styleUrls: ['./zoom-control.component.scss'],
})
export class ZoomControlComponent implements OnInit {
  @Output() zoomChange = new EventEmitter<number>();
  @Input() zoomLevel = 100;
  @Input() minZoom = 50;
  @Input() maxZoom = 150;
  @Input() disabled = false;
  isOpen = false;

  readonly overlayPositions: ConnectedPosition[] = OVERLAY_POSITIONS;

  ngOnInit() {
    const zoomLevel = localStorage.getItem('zoomLevel');
    if (zoomLevel) {
      const parsedZoomLevel = Number(zoomLevel);

      if (parsedZoomLevel) {
        this.zoomLevel = parsedZoomLevel;
      }
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  onZoomChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.zoomLevel = Number(value);
    this.zoomChange.emit(this.zoomLevel);
  }

  resetZoom() {
    this.zoomLevel = 100;
    this.zoomChange.emit(this.zoomLevel);
  }

  get tooltipText(): string {
    return this.zoomLevel === 100 ? '' : `Reset zoom to 100% (current: ${this.zoomLevel}%)`;
  }
}
